import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AnalyticsEventRow } from "@/hooks/useAnalyticsConversao";

interface Props {
  events: AnalyticsEventRow[];
}

const AnonimoLogadoCard: React.FC<Props> = ({ events }) => {
  const total = events.length;
  const logged = events.filter((e) => !!e.user_id).length;
  const anon = total - logged;
  const loggedPct = total ? Math.round((logged / total) * 100) : 0;
  const anonPct = total ? 100 - loggedPct : 0;

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Anônimos vs Logados</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-xs text-muted-foreground">Visitantes anônimos</div>
            <div className="text-2xl font-bold">{anon}</div>
            <div className="text-xs text-muted-foreground mt-1">{anonPct}% dos eventos</div>
          </div>
          <div>
            <div className="text-xs text-muted-foreground">Usuários logados</div>
            <div className="text-2xl font-bold">{logged}</div>
            <div className="text-xs text-muted-foreground mt-1">{loggedPct}% dos eventos</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AnonimoLogadoCard;
